import AppForm from '../app-components/Form/AppForm';

Vue.component('shift-plan-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                employee_contract_id:  '' ,
                from:  '' ,
                to:  '' ,
                
            }
        }
    }

});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/shift-plan/Form.js